import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const forgeServiceDeskEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-forge-servicedesk-queue-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
